import React from 'react'
import { Select, Typography, Row, Col, Avatar, Card} from 'antd'
import moment from 'moment'

import { useGetCryptoNewsQuery } from '../features/bingApi'
import { CircularProgress, Container } from '@mui/material'
import { useState } from 'react'
import { useGetCryptosQuery } from '../features/api'
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const { Text, Title } = Typography
const { Option } = Select

const News = ({simplified}) => {

    const [newsCategory, setNewsCategory] = useState('Cryptocurrency')
    const { data: cryptoNews } = useGetCryptoNewsQuery({newsCategory, count: simplified ? 6 : 12})

    const placeholderImage = 'https://www.pulsecarshalton.co.uk/wp-content/uploads/2016/08/jk-placeholder-image.jpg'

    
    const { data } = useGetCryptosQuery(100);

    return (
        <>
            {!cryptoNews?.value ? <CircularProgress color="secondary" />
            : 
            <>
                <Typography variant="h1" component="h1">News</Typography>  
                <Row gutter={[24, 24]}>
                    {/* {!simplified && (
                        <Col span={24}>
                            <Select
                                showSearch
                                className="select-news"
                                placeholder="Select a Crypto"
                                onChange={(value) => setNewsCategory(value)}
                                filterOption={(input, option) =>
                                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="Cryptocurrency">
                                    {data?.data?.coins?.map((coin) => 
                                        <Option value={coin.name}>{coin.name}</Option>
                                    )}
                                </Option>
                            </Select>
                        </Col>
                    )} */}
                    {cryptoNews.value.map((news, i) => (
                        <Col xs={24} sm={12} lg={8} key={i}>
                            <Card hoverable className="news-card" style={{height:'350px'}}>
                                <a href={news.url} target="_blank" rel="noreferrer">
                                    <div className="news-image-container">
                                        <Title className="news-title" level={4}>
                                            {news.name}
                                        </Title>
                                        <img style={{maxWidth:'100px', maxHeight:'100px'}} alt="news" src={news?.image?.thumbnail?.contentUrl ? news?.image?.thumbnail?.contentUrl : placeholderImage}/>
                                    </div>
                                    <p>
                                        {news.description.length > 100 ? `${news.description.substring(0, 100)}...`
                                        : news.description    
                                        }
                                    </p>
                                    <div className='provider-container'>
                                        <div style={{display:'flex',justifyContent:'center', alignItems:'center'}}>
                                        <AccessTimeIcon sx={{marginRight:'2px'}}/><Text>{moment(news.datePublished).startOf('ss').fromNow()}</Text>
                                        </div>
                                    </div>
                                </a>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </>
      

        } 
        </>
    )
}

export default News
